import {
  Card,
  CardContent,
  CardHeader,
  makeStyles,
  Theme,
  Typography,
} from "@material-ui/core";
import React, { ReactNode } from "react";

const useStyles = makeStyles((theme: Theme) => ({
  root: {
    borderRadius: "0px",
    border: "none",
    boxShadow: "none",
  },
  header: {
    border: "solid 1px grey",
  },
  content: {
    background: "#f0f0f0",
    padding: "0px",
  },
}));

interface Props {
  title: string;
  children?: ReactNode;
}

export const CardWrapper: React.FC<Props> = ({ title, children }) => {
  const classes = useStyles();
  return (
    <Card className={classes.root}>
      <CardHeader
        className={classes.header}
        title={<Typography variant="body1">{title}</Typography>}
      ></CardHeader>
      <CardContent className={classes.content}>{children}</CardContent>
    </Card>
  );
};
